import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Link from "@stackje/shared-components/Link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faYoutube, faInstagram, faTiktok, faXTwitter, faPinterest, faWhatsapp, faFacebook, faLinkedin, faReddit, faDiscord, faTelegram, faSnapchat, faGithub, faGitlab, faTwitch, faVimeo, faMedium, faSpotify, faSoundcloud, faDribbble, faBehance, faMastodon, faWeixin, faLine, faVk, } from "@fortawesome/free-brands-svg-icons";
import { cn } from "@stackje/shared-components/lib/utils";
const getSocialIcon = (platform) => {
    switch (platform) {
        case 'email':
            return faEnvelope;
        case 'youtube':
            return faYoutube;
        case 'instagram':
            return faInstagram;
        case 'tiktok':
            return faTiktok;
        case 'x':
            return faXTwitter;
        case 'pinterest':
            return faPinterest;
        case 'whatsapp':
            return faWhatsapp;
        case 'facebook':
            return faFacebook;
        case 'linkedin':
            return faLinkedin;
        case 'reddit':
            return faReddit;
        case 'discord':
            return faDiscord;
        case 'telegram':
            return faTelegram;
        case 'snapchat':
            return faSnapchat;
        case 'github':
            return faGithub;
        case 'gitlab':
            return faGitlab;
        case 'twitch':
            return faTwitch;
        case 'vimeo':
            return faVimeo;
        case 'medium':
            return faMedium;
        case 'spotify':
            return faSpotify;
        case 'soundcloud':
            return faSoundcloud;
        case 'dribbble':
            return faDribbble;
        case 'behance':
            return faBehance;
        case 'mastodon':
            return faMastodon;
        case 'weixin':
            return faWeixin;
        case 'line':
            return faLine;
        case 'vk':
            return faVk;
        default:
            return faEnvelope;
    }
};
const getSizeClasses = (size) => {
    switch (size) {
        case 'sm':
            return 'w-4 h-4';
        case 'md':
            return 'w-5 h-5';
        case 'lg':
            return 'w-6 h-6';
        default:
            return 'w-5 h-5';
    }
};
export default function SocialMediaIcons({ links, colors, size = "md", className }) {
    if (!links || links.length === 0) {
        return null;
    }
    return (_jsx("div", { className: cn("flex gap-4 justify-center items-center", className), children: links.map((link, index) => (_jsx(Link, { to: link.url, title: link.displayName || link.platform, className: "hover:opacity-70 transition-opacity", target: link.url.startsWith('mailto:') ? undefined : '_blank', rel: link.url.startsWith('mailto:') ? undefined : 'noopener noreferrer', children: _jsx(FontAwesomeIcon, { icon: getSocialIcon(link.platform), className: cn(getSizeClasses(size), `text-${colors.foreground}`) }) }, index))) }));
}
